// src/MicrosoftIcon.tsx
import { jsx } from "react/jsx-runtime";
var MicrosoftIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 40,
    height: 40,
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    baseProfile: "full",
    enableBackground: "new 0 0 76.00 76.00",
    xmlSpace: "preserve",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        fillOpacity: "1",
        strokeLinejoin: "round",
        d: "M 19,19L 37,19L 37,37L 19,37L 19,19 Z M 57,19L 57,37L 39,37L 39,19L 57,19 Z M 57,57L 39,57L 39,39L 57,39L 57,57 Z M 19,57L 19,39L 37,39L 37,57L 19,57 Z "
      }
    )
  }
);

export {
  MicrosoftIcon
};
